import React from 'react';
import { withRenderFlag } from '@beef/react';
import { Button, Link } from '@beef/ui-kit';

import Ctx from 'pages-components/Ctx';

import { FloatingConnectButton as FloatingConnectButtonContainer } from './FloatingConnectButton';
import { useESimModalState } from '../../useESimModalState';

interface IProps {
  esim?: {
    text: string;
  };
  isConnected: boolean;
  isLayoutYoung: boolean;
}

const _FloatingConnectButton: React.FC<IProps> = (props) => {
  const [_, toogleESimModal] = useESimModalState();

  return (
    <FloatingConnectButtonContainer>
      {props.esim && (
        <div>
          <Button fullWidth onClick={toogleESimModal} variant="secondary">
            {props.esim.text}
          </Button>
        </div>
      )}

      {props.isConnected && props.isLayoutYoung && (
        <div>
          <Link
            buttonSize="l"
            buttonVariant="main"
            href="/customers/products/elk/"
            isFullWidth
            variant="button"
          >
            {Ctx.tariff.configureBtnText}
          </Link>
        </div>
      )}
    </FloatingConnectButtonContainer>
  );
};

export const FloatingConnectButton: React.FC<IProps & { shouldRender: boolean }> =
  withRenderFlag(_FloatingConnectButton);
